module.exports = __webpack_public_path__ + "static/img/default_view_orders_list.1bd6e172.png";